<template>
	<g>
		<rect class="frontRect" :x="x" :y="y" :width="width" :height="height" />
		<polygon class="topPolygon" :points="topPolygon" />
		<polygon class="rightPolygon" :points="rightPolygon" />
	</g>
</template>

<script>
	export default {
		name: 'Rack',
		props: {
			width: Number,
			height: Number,
			x: Number,
			y: Number,
		},
		computed: {
			xOffset() {
				return this.width / 1.8;
			},
			yOffset() {
				return this.width / 3;
			},
			topPolygon() {
				return `${this.x + this.width},${this.y}
						${this.x},${this.y}
						${this.x + this.xOffset},${this.y - this.yOffset}
						${this.x + this.width + this.xOffset},${this.y - this.yOffset}`;
			},
			rightPolygon() {
				return `${this.x + this.width + this.xOffset},${this.height + this.y - this.yOffset}
						${this.x + this.width},${this.height + this.y}
						${this.x + this.width},${this.y}
						${this.x + this.width + this.xOffset},${this.y - this.yOffset}`;
			},
		},
	};
</script>

<style scoped>
	.frontRect {
		fill:#C4C6C8;
	}
	.topPolygon {
		fill: #DCDDDE;
	}
	.rightPolygon {
		fill: #9D9FA2;
	}
</style>